$bog_pazzle_play $mol_view
	moves 0
	time \
	peek? false
	again? null
	Game $bog_pazzle_board
	sub /
		<= Toolbar $mol_view
			sub /
				<= Clock $mol_text
					text <= time
				<= Moves $mol_text
					text <= moves_label \
				<= Filler $mol_view
				<= Peek_toggle $mol_check_box
					title \Оригинал
					hint \Показать картинку целиком
					checked? <=> peek?
				<= Again $mol_button_minor
					title \Заново
					hint \Перемешать и начать партию сначала
					click? <=> again?
		<= Game
